export const SET_ALL_COMBOS = "SET_ALL_COMBOS"
export const UPDATE_COMBOS = "UPDATE_COMBOS"
export const UPDATE_COMBO = "UPDATE_COMBO"
export const ADD_COMBO = "ADD_COMBO"
export const DELETE_COMBO = "DELETE_COMBO"
export const CLEAR_COMBOS = "CLEAR_COMBOS"